import { ComponentIds } from '@inter-ikea-core/core';
import { DistanceMeasurementComponent, PlannerEcsSystem, ProductType } from '@inter-ikea-storageone/range';
import { Direction } from '@inter-ikea-storageone/range/src/core-api/components/DistanceMeasurementComponent';
/**
 * Adds DistanceMeasurementComponent to BOAXEL mounting rail
 */
export class BoaxelDistanceMeasurementSystem extends PlannerEcsSystem {
    constructor(coreApi) {
        super(coreApi, 'BoaxelDistanceMeasurementSystem', ComponentIds.MOVED_TO_VALID_SNAP_POSITION_COMPONENT_ID);
    }
    onAdd(entity) {
        if (this.coreApi.entities.isProductType(entity, ProductType.BOAXEL_NON_MOUNTING_RAIL)) {
            if (!entity.hasComponent(DistanceMeasurementComponent.id)) {
                entity.addComponent(new DistanceMeasurementComponent([Direction.LEFT, Direction.RIGHT]));
            }
        }
    }
    onUpdate() { }
    onRemove() { }
}
//# sourceMappingURL=BoaxelDistanceMeasurementSystem.js.map